import Button from 'react-bootstrap/Button'
import { redirectToLabBaseAuthPage } from '@/util/auth'

export default function Intro() {
  return (
    <>
      <h1>高専生の今と</h1>
      <h1 className="text-secondary">未来を繋ぐ</h1>
      <p>
        KOSEN
        NODEは、高専生一人ひとりがワクワクするキャリアの選択肢に出会え、自分自身でキャリアを選べる世界を作ります。
      </p>
      <Button
        variant="outline-primary"
        onClick={() => redirectToLabBaseAuthPage('/login', 'signup/select')}
      >
        新規登録
      </Button>
    </>
  )
}
